import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BusinessUser } from '@models/businesses';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { collections } from '@models/collections';

export class BusinessAccount {
	public name: string;
	public isActive: boolean;
	public businessId: string;
}

/**
 * Multi-Business Service.
 * Service for gathering all businesses a User is a part of.
 */
@Injectable()
export class UserBusinessesService extends FirestoreRepo<BusinessUser, null> {
	private userBusinessesAccountBehaviorSubject = new BehaviorSubject<
		BusinessAccount[]
	>([]);

	constructor() {
		super(() => collections.business_users);
	}

	public setUserBusinesses(userBusinesses: BusinessAccount[]): void {
		this.userBusinessesAccountBehaviorSubject.next(userBusinesses);
	}

	public get userBusinessesAccounts$(): Observable<BusinessAccount[]> {
		return this.userBusinessesAccountBehaviorSubject.asObservable();
	}
}
